/**
 * API index - Export all API functions for clean imports
 */

// Base API utilities
export * from './base';

// Page-specific API functions
export * from './about-page';
export * from './contact';
export * from './footer';
export * from './header';
export * from './landing-page';
export * from './news';
export * from './product';
export * from './products-category';
export * from './project';
export * from './services-page';
